import { StateUtils } from '@spartacus/core';
import { WishlistEntry } from '@wishlist/const';
import { WISHLIST_ADD_ENTRY } from '../wishlist-state';

export const ADD_WISHLIST_ENTRY = '[Wishlist] Add Wishlist Entry';
export const ADD_WISHLIST_ENTRY_SUCCESS = '[Wishlist] Add Wishlist Entry Success';
export const ADD_WISHLIST_ENTRY_FAIL = '[MyAccount] Add Wishlist Entry Fail';

export class AddWishlistEntry extends StateUtils.EntityLoadAction {
  readonly type = ADD_WISHLIST_ENTRY;

  constructor(public payload: WishlistEntry) {
    super(WISHLIST_ADD_ENTRY, payload.productCode);
  }
}

export class AddWishlistEntrySuccess extends StateUtils.EntitySuccessAction {
  readonly type = ADD_WISHLIST_ENTRY_SUCCESS;

  constructor(public payload: WishlistEntry) {
    super(WISHLIST_ADD_ENTRY, payload.productCode);
  }
}

export class AddWishlistEntryFail extends StateUtils.EntityFailAction {
  readonly type = ADD_WISHLIST_ENTRY_FAIL;

  constructor(
    public payload: WishlistEntry,
    error: unknown,
  ) {
    super(WISHLIST_ADD_ENTRY, payload.productCode, error);
  }
}

export type AddWishlistEntryActions = AddWishlistEntry | AddWishlistEntrySuccess | AddWishlistEntryFail;
